import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import '../../../../../css/web/bedloophotel/blog.css';
import CabeceraPagina from '../Compartido/CabeceraPagina.jsx';

const ListaNoticias = ({ noticias, ruta, lang, config }) => {

    const { t } = useTranslation();

    var imagen = ruta + "/blog/cabecera/cabecera.jpg";

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const destacadas = noticias.slice(0, 3);
    const resto = noticias.slice(3);

    const renderCard = (unanoticia, index, destacada) => {
        const href = "/" + preidioma + t("blog") + "/" + unanoticia.laurl;
        const img = unanoticia.imagen
            ? ruta + "/blog/" + unanoticia.id + "/" + unanoticia.imagen
            : "/images/web/bedloop-nofoto.png";
        const tag = unanoticia.tags ? unanoticia.tags.split(',')[0].trim() : "";

        return (
            <article className={destacada ? "bh-blog__item bh-blog__item--destacada" : "bh-blog__item"} key={index}>
                <a href={href} className="bh-blog__media">
                    <LazyLoadImage effect='blur' threshold={10} src={img} alt={unanoticia.eltitulo} />
                </a>
                <div className="bh-blog__body">
                    <div className="bh-blog__meta">
                        {unanoticia.fecha_publica && <span className="bh-blog__fecha">{unanoticia.fecha_publica}</span>}
                        {tag && <span className="bh-blog__tag">{tag}</span>}
                    </div>
                    <h2 className="bh-blog__titulo"><a href={href}>{unanoticia.eltitulo}</a></h2>
                    {destacada && unanoticia.elsubtitulo && <p className="bh-blog__desc">{unanoticia.elsubtitulo}</p>}
                    <a href={href} className="bh-blog__link">
                        {t("leer más")}
                        <i className="fa-solid fa-plus"></i>
                    </a>
                </div>
            </article>
        );
    };

    return (
        <div className="bh-blog">
            <CabeceraPagina titulo={t("Blog")} eyebrow={t("Diario de viaje")} imagen={imagen} />

            <div className="container">
                <div className="bh-blog__featured">
                    {destacadas.map((unanoticia, index) => renderCard(unanoticia, index, true))}
                </div>

                {resto.length > 0 && (
                    <div className="bh-blog__compact">
                        {resto.map((unanoticia, index) => renderCard(unanoticia, "r" + index, false))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ListaNoticias;
